var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin__a-tab-content admin__a-tab-content--show"},[_c('br'),_c('specifiсation-table',{attrs:{"lot":_vm.lot,"retend":_vm.retend}}),_c('br'),_c('payments-and-parts',{attrs:{"retend":_vm.retend,"lot":_vm.lot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }